import React from "react";
import { heroVideoUrl } from "../mock";

const Hero = () => {
  return (
    <section
      id="hero"
      className="relative w-full min-h-screen overflow-hidden bg-neutral-900" data-nav-theme="dark"
    >
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      >
        <source src={heroVideoUrl} type="video/mp4" />
      </video>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/65" />

      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-6 text-center">
        <h1
          className="font-fashion-serif uppercase text-white leading-[0.95]"
          style={{ fontSize: "clamp(56px, 10vw, 170px)" }}
        >
          Maison Labroca
        </h1>
        <p className="mt-6 text-white/90 text-[16px] md:text-[18px] italic flex items-center gap-4">
          <span className="w-8 h-px bg-[#9F8B76]" />
          Une histoire de famille au service de la vôtre !
          <span className="w-8 h-px bg-[#9F8B76]" />
        </p>
      </div>

      {/* Scroll hint */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 hidden md:flex flex-col items-center gap-2 text-white/70 text-[11px] uppercase tracking-[0.3em]">
        <span>Découvrir</span>
        <span className="w-px h-8 bg-white/40 animate-pulse" />
      </div>
    </section>
  );
};

export default Hero;
